import Skeleton from 'react-loading-skeleton';
import RelatedListingsLoader from '~/pages/LeadFollowUp/RelatedListingsLoader';
import TopSellersLoader from '~/pages/LeadFollowUp/TopSellersLoader';

export default function LeadFollowUpLoading() {
  return (
    <div className="flex w-full flex-col gap-3x px-2x py-3x md:gap-4x md:px-5x md:py-4x">
      <div className="flex flex-col items-center gap-x">
        <Skeleton width={320} height={32} containerClassName="leading-none" />
        <Skeleton width={480} height={24} containerClassName="leading-none" />
      </div>
      <TopSellersLoader />
      <RelatedListingsLoader />
    </div>
  );
}
